{
  "privacy": {
    "consentTitle": "Privacidade e analytics",
    "consentBody": "Usamos analytics para melhorar o produto e crash reports para encontrar erros. Escolhe o que queres permitir. Podes alterar em Conta → Privacidade.",
    "analyticsLabel": "Analytics de uso",
    "analyticsDesc": "Mixpanel/Google Analytics para métricas de produto e funil. Se recusar, contamos apenas passos do funil de forma agregada e anónima (sem identificadores, sem Mixpanel/GA).",
    "crashLabel": "Crash reports",
    "crashDesc": "Sentry para erros técnicos, estabilidade e diagnóstico.",
    "acceptAll": "Aceitar tudo",
    "rejectAll": "Recusar tudo",
    "saveChoices": "Guardar escolhas",
    "settingsItemTitle": "Privacidade",
    "settingsItemDesc": "Analytics, crash reports e opt-out",
    "accountSection": "Conta",
    "sectionTitle": "Consentimento de dados",
    "sectionBody": "Controla separadamente analytics de produto e crash reports. Ao desligar, novas chamadas deixam de ser enviadas.",
    "savePreferences": "Guardar preferências",
    "saved": "Preferências de privacidade guardadas."
  },
  "errorBoundary": {
    "title": "Algo correu mal",
    "message": "Ocorreu um erro inesperado. Já fomos notificados. Podes tentar novamente ou contactar o suporte.",
    "retry": "Tentar novamente",
    "contactSupport": "Contactar suporte"
  },
  "loginTitle": "Login",
  "emailPlaceholder": "Email",
  "passwordPlaceholder": "Palavra-passe",
  "loginButton": "Entrar",
  "signupPrompt": "Não tem uma conta?",
  "signupLink": "Registar",
  "loginError": "Por favor, introduza o email e a palavra-passe.",
  "loginFailed": "Email ou palavra-passe incorretos.",
  "loginSuccess": "Bem-vindo, {{email}}!",
  "registerChoiceTitle": "Registar",
  "chooseRolePrompt": "Escolha como deseja registar-se: Condutor ou Proprietário de Frota. Se for ambos, registe-se como Proprietário.",
  "driverButton": "Condutor",
  "ownerButton": "Proprietário de Frota",
  "registerDriverTitle": "Registo de Condutor",
  "nifPlaceholder": "NIF",
  "addressPlaceholder": "Morada",
  "licenseTypePlaceholder": "Tipo de Licença",
  "licenseNumberPlaceholder": "CMTVDE",
  "workStartDatePlaceholder": "Data de Início de Trabalho",
  "dobPlaceholder": "Data de Nascimento",
  "dateOfBirthPlaceholder": "Data de Nascimento",
  "dualRoleMessage": "Se você é tanto Proprietário quanto Condutor, registe-se como Proprietário.",
  "registerOwnerTitle": "Registar como Proprietário de Frota",
  "submitButton": "Enviar",
  "fullNamePlaceholder": "Nome Completo",
  "phoneNumberPlaceholder": "Número de Telefone",
  "companyNamePlaceholder": "Nome da Empresa",
  "companyEmailPlaceholder": "Email da Empresa",
  "nipcPlaceholder": "NIPC",
  "certidaoPermanentePlaceholder": "Certidão Permanente",
  "numeroLicencaPlaceholder": "CMTVDE",
  "registerSuccess": "Registo efetuado com sucesso!",
  "registerFailed": "O registo falhou.",
  "goBack": "Voltar",
  "userInformation": "Informação do Utilizador",
  "companyInformation": "Informação da Empresa",
  "forgotPassword": "Esqueceu a sua palavra-passe?",
  "invalidEmail": "Email inválido",
  "invalidPassword": "Palavra-passe deve ter no mínimo 8 caracteres.",
  "requiredField": "Campo obrigatório.",
  "registrationSuccessTitle": "Registado com sucesso!",
  "registrationSuccessMessage": "Confirme o seu email para completar o registo.",
  "emailVerifiedSuccessfully": "Email verificado com sucesso!",
  "okButton": "OK",
  "drivingTimeToday": "Condução hoje",
  "startDriving": "Iniciar condução",
  "drivingStates": {
    "starting": "A iniciar...",
    "stopping": "A parar...",
    "endingSession": "A terminar sessão...",
    "processing": "A processar..."
  },
  "startSession": "Iniciar Sessão",
  "close": "Fechar",
  "waitingForActivation": "Ativação pendente",
  "pendingSelfPayHint": "Não quer esperar? Pode ativar já a sua própria licença.",
  "pendingSelfPayCta": "Eu pago a minha licença",
  "pendingEmploymentMessage": "Aguarde a empresa {{nipc}} ativar o seu perfil.",
  "addAnotherCompany": "Adicionar outra empresa",
  "addCompanyInfo": "Adicionar Informações da Empresa responsável pela frota",
  "back": "Voltar",
  "addVehicleInfo": "Adicionar Veículo",
  "registrationNumber": "Matrícula",
  "make": "Marca",
  "model": "Modelo",
  "fuelType": {
    "gasolina": "Gasolina",
    "gasoleo": "Gasóleo",
    "bifuel": "Bi-fuel",
    "hibrido": "Híbrido",
    "eletrico": "Elétrico"
  },
  "endSession": "Terminar Sessão",
  "stopDriving": "Parar de Conduzir",
  "selectVehicle": "Selecione um veículo",
  "errorStartingSession": "Erro ao iniciar a sessão",
  "errorEndingSession": "Erro ao terminar a sessão",
  "errorStartingDriving": "Erro ao iniciar a condução",
  "errorStoppingDriving": "Erro ao parar de conduzir",
  "odometer": "KM atual",
  "weeklyDrivingReport": "Relatórios Semanais",
  "driverDetails": "Detalhes do Condutor",
  "companyDetails": "Detalhes da Empresa",
  "name": "Nome",
  "phoneNumber": "Número de Telefone",
  "dateOfBirth": "Data de Nascimento",
  "nif": "NIF",
  "address": "Morada",
  "licenseNumber": "CMTVDE",
  "companyName": "Nome da Empresa",
  "nipc": "NIPC",
  "companyEmail": "Email da Empresa (Opcional)",
  "totalWeek": "Total da Semana",
  "loading": {
    "default": "A carregar...",
    "checkingData": "Verificando dados...",
    "loadingVehicles": "A carregar veículos...",
    "loadingData": "A carregar dados...",
    "userInformation": "A carregar informações do utilizador..."
  },
  "driverDashboard": {
    "noVehicleAssignedTitle": "Sem veículo atribuído",
    "noVehicleAssignedRecoveryMessage": "Está em modo Condutor mas ainda não tem um veículo atribuído. Pode continuar a configuração do veículo ou voltar ao perfil de Proprietário.",
    "noVehicleAssignedDriverOnlyMessage": "A sua empresa ainda não lhe atribuiu um veículo. Pode continuar a configuração agora ou voltar mais tarde.",
    "continueVehicleSetup": "Continuar configuração do veículo",
    "redirectingToVehicleSetup": "A redirecionar para a configuração do veículo..."
  },
  "noReport": "Nenhum relatório disponível",
  "notProvided": "Não fornecido",
  "noLocation": "Sem localização",
  "reports": "Relatórios",
  "nextWeek": "Semana Seguinte",
  "previousWeek": "Semana Anterior",
  "exportPDF": "Exportar PDF",
  "errorExportingPDF": "Erro ao exportar o PDF",
  "home": "Início",
  "logout": "Sair",
  "settings": "Definições",
  "switchToDriver": "Mudar para Condutor",
  "switchToOwner": "Mudar para Proprietário",
  "receiveNotifications": "Receber Notificações",
  "stopTimeThreshold": "Tempo Parado (minutos)",
  "distanceThreshold": "Distância para Alerta (metros)",
  "save": "Guardar",
  "preferencesSaved": "Preferências guardadas!",
  "errorSavingPreferences": "Erro ao guardar preferências.",
  "sessionInactive": "Sessão inativa",
  "sessionActive": "Sessão ativa",
  "driving": "A conduzir",
  "locationExplanation": "Precisamos de acesso à localização o tempo todo para monitorizar a sua condução e enviar alertas quando necessário.",
  "foregroundLocation": "Localização em Primeiro Plano",
  "backgroundLocation": "Localização em Segundo Plano",
  "enabled": "Ativado",
  "enable": "Ativar",
  "goToSettings": "Ir para Definições",
  "permissionDenied": "Permissão Negada",
  "permissionExplanation": "Precisamos da permissão de {{type}} para monitorizar a sua localização e enviar notificações em tempo real.",
  "vehicleRegistration": "Matrícula do Veículo",
  "odometerStart": "KM Inicial",
  "odometerEnd": "KM Final",
  "drivingTime": "Tempo de Condução",
  "availabilityTime": "Tempo de Disponibilidade",
  "restTime": "Tempo de Descanso",
  "logs": "Registos",
  "observations": "Observações",
  "totalWeekDriving": "Total da Semana (Condução)",
  "totalWeekAvailability": "Total da Semana (Disponibilidade)",
  "totalWeekRest": "Total da Semana (Descanso)",
  "eventType": "Tipo de Evento",
  "start": "Início",
  "end": "Fim",
  "startLocation": "Local de Início",
  "endLocation": "Local de Fim",
  "total": "Total",
  "available": "Disponível",
  "notificationSettings": "Definições de notificações",
  "permissions": "Permissões",
  "status": "Estado",
  "cancel": "Cancelar",
  "currentWeek": "Semana Atual",
  "selectWeek": "Selecionar Semana",
  "selectedWeek": "Semana Selecionada",
  "selectDate": "Selecionar Data",
  "select": "Selecionar",
  "clickDateToSelectWeek": "Clique numa data para selecionar essa semana",
  "email": "Email",
  "daily-report": "Relatório do dia",
  "dailyDrivingReport": "Relatório do dia",
  "dateOfBirthRequired": "A data de nascimento é obrigatória",
  "licenseNumberOperadorPlaceholder": "Nº Licença de Operador",
  "numeroLicencaOperadorRequired": "O número da licença de operador é obrigatório",
  "numeroLicencaOperadorInvalidLength": "O número da licença de operador deve ter até 10 dígitos antes da barra",
  "numeroLicencaOperadorInvalidFormat": "Formato da licença de operador inválido. Use N.../AAAA.",
  "licenseNumberInvalidFormat": "Formato da CMTVDE inválido. Use NNNNNNNN+/AAAA.",
  "countries": {
    "portugal": "Portugal",
    "afghanistan": "Afeganistão",
    "albania": "Albânia",
    "algeria": "Argélia",
    "andorra": "Andorra",
    "angola": "Angola",
    "antiguaAndBarbuda": "Antígua e Barbuda",
    "argentina": "Argentina",
    "armenia": "Arménia",
    "australia": "Austrália",
    "austria": "Áustria",
    "azerbaijan": "Azerbaijão",
    "bahamas": "Bahamas",
    "bahrain": "Barém",
    "bangladesh": "Bangladeche",
    "barbados": "Barbados",
    "belarus": "Bielorrússia",
    "belgium": "Bélgica",
    "belize": "Belize",
    "benin": "Benim",
    "bhutan": "Butão",
    "bolivia": "Bolívia",
    "bosniaAndHerzegovina": "Bósnia e Herzegovina",
    "botswana": "Botswana",
    "brazil": "Brasil",
    "brunei": "Brunei",
    "bulgaria": "Bulgária",
    "burkinaFaso": "Burkina Faso",
    "burundi": "Burundi",
    "cambodia": "Camboja",
    "cameroon": "Camarões",
    "canada": "Canadá",
    "capeVerde": "Cabo Verde",
    "centralAfricanRepublic": "República Centro-Africana",
    "chad": "Chade",
    "chile": "Chile",
    "china": "China",
    "colombia": "Colômbia",
    "comoros": "Comores",
    "congo": "Congo",
    "costaRica": "Costa Rica",
    "croatia": "Croácia",
    "cuba": "Cuba",
    "cyprus": "Chipre",
    "czechRepublic": "República Checa",
    "denmark": "Dinamarca",
    "djibouti": "Djibuti",
    "dominica": "Dominica",
    "dominicanRepublic": "República Dominicana",
    "ecuador": "Equador",
    "egypt": "Egito",
    "elSalvador": "El Salvador",
    "equatorialGuinea": "Guiné Equatorial",
    "eritrea": "Eritreia",
    "estonia": "Estónia",
    "ethiopia": "Etiópia",
    "fiji": "Fiji",
    "finland": "Finlândia",
    "france": "França",
    "gabon": "Gabão",
    "gambia": "Gâmbia",
    "georgia": "Geórgia",
    "germany": "Alemanha",
    "ghana": "Gana",
    "greece": "Grécia",
    "grenada": "Granada",
    "guatemala": "Guatemala",
    "guinea": "Guiné",
    "guineaBissau": "Guiné-Bissau",
    "guyana": "Guiana",
    "haiti": "Haiti",
    "honduras": "Honduras",
    "hongKong": "Hong Kong",
    "hungary": "Hungria",
    "iceland": "Islândia",
    "india": "Índia",
    "indonesia": "Indonésia",
    "iran": "Irão",
    "iraq": "Iraque",
    "ireland": "Irlanda",
    "israel": "Israel",
    "italy": "Itália",
    "jamaica": "Jamaica",
    "japan": "Japão",
    "jordan": "Jordânia",
    "kazakhstan": "Cazaquistão",
    "kenya": "Quénia",
    "kiribati": "Quiribáti",
    "koreaSouth": "Coreia do Sul",
    "kuwait": "Kuwait",
    "kyrgyzstan": "Quirguistão",
    "laos": "Laos",
    "latvia": "Letónia",
    "lebanon": "Líbano",
    "lesotho": "Lesoto",
    "liberia": "Libéria",
    "libya": "Líbia",
    "liechtenstein": "Liechtenstein",
    "lithuania": "Lituânia",
    "luxembourg": "Luxemburgo",
    "macau": "Macau",
    "macedonia": "Macedónia",
    "madagascar": "Madagáscar",
    "malawi": "Malawi",
    "malaysia": "Malásia",
    "maldives": "Maldivas",
    "mali": "Mali",
    "malta": "Malta",
    "marshallIslands": "Ilhas Marshall",
    "mauritania": "Mauritânia",
    "mauritius": "Maurícia",
    "mexico": "México",
    "micronesia": "Micronésia",
    "moldova": "Moldávia",
    "monaco": "Mónaco",
    "mongolia": "Mongólia",
    "montenegro": "Montenegro",
    "morocco": "Marrocos",
    "mozambique": "Moçambique",
    "myanmar": "Myanmar",
    "namibia": "Namíbia",
    "nauru": "Nauru",
    "nepal": "Nepal",
    "netherlands": "Países Baixos",
    "newZealand": "Nova Zelândia",
    "nicaragua": "Nicarágua",
    "niger": "Níger",
    "nigeria": "Nigéria",
    "norway": "Noruega",
    "oman": "Omã",
    "pakistan": "Paquistão",
    "palau": "Palau",
    "palestine": "Palestina",
    "panama": "Panamá",
    "papuaNewGuinea": "Papua-Nova Guiné",
    "paraguay": "Paraguai",
    "peru": "Peru",
    "philippines": "Filipinas",
    "poland": "Polónia",
    "qatar": "Catar",
    "romania": "Roménia",
    "russia": "Rússia",
    "rwanda": "Ruanda",
    "saudiArabia": "Arábia Saudita",
    "senegal": "Senegal",
    "serbia": "Sérvia",
    "seychelles": "Seicheles",
    "sierraLeone": "Serra Leoa",
    "singapore": "Singapura",
    "slovakia": "Eslováquia",
    "slovenia": "Eslovénia",
    "solomonIslands": "Ilhas Salomão",
    "somalia": "Somália",
    "southAfrica": "África do Sul",
    "southSudan": "Sudão do Sul",
    "spain": "Espanha",
    "sriLanka": "Sri Lanka",
    "sudan": "Sudão",
    "suriname": "Suriname",
    "swaziland": "Suazilândia",
    "sweden": "Suécia",
    "switzerland": "Suíça",
    "syria": "Síria",
    "taiwan": "Taiwan",
    "tajikistan": "Tajiquistão",
    "tanzania": "Tanzânia",
    "thailand": "Tailândia",
    "timorLeste": "Timor-Leste",
    "togo": "Togo",
    "tonga": "Tonga",
    "trinidadAndTobago": "Trindade e Tobago",
    "tunisia": "Tunísia",
    "turkey": "Turquia",
    "turkmenistan": "Turquemenistão",
    "tuvalu": "Tuvalu",
    "uganda": "Uganda",
    "ukraine": "Ucrânia",
    "unitedArabEmirates": "Emirados Árabes Unidos",
    "unitedKingdom": "Reino Unido",
    "unitedStates": "Estados Unidos",
    "uruguay": "Uruguai",
    "uzbekistan": "Uzbequistão",
    "vanuatu": "Vanuatu",
    "vaticanCity": "Cidade do Vaticano",
    "venezuela": "Venezuela",
    "vietnam": "Vietname",
    "yemen": "Iémen",
    "zambia": "Zâmbia",
    "zimbabwe": "Zimbabué"
  },
  "searchCountry": "Procurar país",
  "phoneNumberInvalid": "O número de telefone deve ter pelo menos 8 dígitos",
  "locationBackgroundPermissionTitle": "Localização (Segundo plano)",
  "locationBackgroundPermissionDescription": "Para continuar rastreando mesmo quando o app estiver fechado",
  "locationBackgroundPermissionImportant": "Importante: Para receber notificações quando estiver parado no mesmo local por muito tempo, você precisa selecionar 'Permitir sempre' nas configurações de localização do seu dispositivo.",
  "lastOdometerReading": "Última Leitura",
  "latestOdometerReading": "Última Leitura",
  "comingSoon": "Brevemente",
  "ownerRegistrationContact": "Interessado em registar-se como proprietário? Contacte-nos em:",
  "companyPhone": "Telefone da Empresa (Opcional)",
  "companyInfo": {
    "menu": "Empresa",
    "title": "Empresa",
    "emailChangeNotice": "Alterar o email da empresa pode exigir verificação."
  },
  "failedToLoadCompany": "Falha ao carregar informações da empresa",
  "failedToUpdateCompany": "Falha ao atualizar a empresa",
  "companyUpdated": "Detalhes da empresa atualizados com sucesso",
  "emailUpdated": "Email atualizado",
  "emailNeedsVerification": "Por favor, verifique o seu email para confirmar o novo email da empresa.",
  "completeDriverProfile": {
    "menu": "Completar Perfil de Condutor",
    "modalTitle": "Tornar-me motorista",
    "boundaryNotice": "Vai usar uma das licenças livres da empresa.",
    "errorTitle": "Não foi possível guardar o perfil",
    "genericError": "Ocorreu um erro ao guardar o perfil. Tente novamente.",
    "networkError": "Não foi possível contactar o servidor. Tente novamente.",
    "submit": "Guardar perfil",
    "becomeDriverSubmit": "Tornar-me motorista"
  },
  "userData": {
    "title": "Perfil",
    "languageTitle": "Definições de Idioma",
    "currentLanguage": "Idioma Atual",
    "profileTitle": "Meu Perfil",
    "vehicleTitle": "Meu Veículo",
    "companyTransferTitle": "Solicitar Transferência de Empresa",
    "editProfile": "Editar Perfil",
    "editVehicle": "Editar Veículo",
    "requestTransfer": "Solicitar Transferência",
    "currentCompany": "Empresa Atual",
    "notAvailable": "N/A",
    "noVehicleData": "Sem informações do veículo disponíveis.",
    "fullName": "Nome Completo",
    "email": "Email",
    "phoneNumber": "Número de Telefone",
    "dateOfBirth": "Data de Nascimento",
    "nif": "NIF",
    "address": "Morada",
    "licenseType": "Tipo de Carta",
    "licenseNumber": "Número da Carta",
    "workStartDate": "Data de Início de Trabalho",
    "notificationPreferences": "Preferências de Notificação",
    "receiveNotifications": "Receber Notificações",
    "stopTimeThreshold": "Limiar de Tempo de Paragem",
    "distanceThreshold": "Limiar de Distância",
    "languageChanged": "Idioma alterado com sucesso.",
    "languageChangeError": "Falha ao alterar o idioma.",
    "loadError": "Falha ao carregar dados.",
    "updateError": "Falha ao atualizar perfil.",
    "profileUpdateSuccess": "Perfil atualizado com sucesso.",
    "vehicleLoadError": "Não foi possível carregar os detalhes do veículo.",
    "vehicleUpdateSuccess": "Detalhes do veículo atualizados.",
    "vehicleUpdateError": "Falha ao atualizar detalhes do veículo.",
    "vehicleIdMissing": "ID do veículo em falta, não é possível atualizar.",
    "transferSuccess": "Pedido de transferência de empresa solicitado.",
    "transferError": "Falha ao solicitar transferência de empresa.",
    "invalidNipc": "NIPC inválido. Deve ser um número de 9 dígitos começando com 5.",
    "contactMethodRequired": "Por favor, forneça um email ou número de telefone para a nova empresa.",
    "newCompanyName": "Nome da Nova Empresa",
    "newCompanyNipc": "NIPC da Nova Empresa",
    "companyEmail": "Email da Empresa (Opcional)",
    "companyPhone": "Telefone da Empresa (Opcional)",
    "transferReason": "Motivo da Transferência",
    "submitRequest": "Submeter Pedido",
    "editVehicleTitle": "Editar Detalhes do Veículo",
    "requestTransferTitle": "Solicitar Transferência de Empresa",
    "emailChangeSuccess": "Email atualizado. Por favor, verifique o seu novo email para confirmar. Será desconectado.",
    "changeEmailTitle": "Alterar Email",
    "changeEmailHint": "Vai precisar de confirmar o novo email antes de este ficar ativo.",
    "emailEditHint": "Para alterar o seu email, use a secção \"Alterar Email\" abaixo.",
    "newEmail": "Novo email",
    "requestEmailChange": "Pedir alteração de email",
    "resendConfirmation": "Reenviar email de confirmação",
    "resendInSeconds": "Reenviar em {{seconds}}s",
    "emailChangePendingMessage": "Enviámos um link de confirmação para {{email}}. Clique nele para concluir a alteração do seu email.",
    "emailChangeRequestSuccess": "Se o pedido for válido, enviámos um email de confirmação para o novo endereço.",
    "emailChangeRateLimited": "Aguarde um pouco antes de tentar novamente.",
    "emailChangeError": "Falha ao pedir a alteração de email.",
    "emailInvalid": "Introduza um endereço de email válido."
  },
  "vehicle": {
    "year": "Ano",
    "licensePlate": "Matrícula",
    "make": "Marca",
    "model": "Modelo",
    "fuelType": "Combustível",
    "selectFuelType": "Selecionar combustível"
  },
  "units": {
    "min": "min",
    "m": "m"
  },
  "ok": "OK",
  "manageInStripe": "Gerir no Stripe",
  "manageSubscription": "Gerir Subscrição",
  "resetPasswordButton": "Enviar Link de Redefinição",
  "changePasswordButton": "Alterar Palavra-passe",
  "resetPasswordSuccess": "Se existir uma conta com este email, receberá instruções para redefinir a palavra-passe.",
  "resetPasswordError": "Ocorreu um erro ao solicitar a redefinição da palavra-passe. Por favor, tente novamente.",
  "resetPasswordFailed": "Não foi possível enviar o email de redefinição da palavra-passe.",
  "currentPasswordPlaceholder": "Palavra-passe atual",
  "newPasswordPlaceholder": "Nova Palavra-passe",
  "confirmPasswordPlaceholder": "Confirmar Nova Palavra-passe",
  "passwordChangeSuccess": "A sua palavra-passe foi alterada com sucesso.",
  "passwordsDontMatch": "As palavras-passe não coincidem",
  "passwordResetSuccess": "A sua palavra-passe foi redefinida com sucesso. Por favor, faça login com a sua nova palavra-passe.",
  "passwordResetError": "Ocorreu um erro ao redefinir a sua palavra-passe. O link pode ter expirado.",
  "allFieldsRequired": "Por favor, preencha todos os campos",
  "networkError": "Erro de rede. Por favor, tente novamente.",
  "enterNewPassword": "Introduza a sua nova palavra-passe abaixo.",
  "invalidResetLink": "Link de redefinição de palavra-passe inválido. Por favor, solicite um novo.",
  "resetPasswordTitle": "Redefinir Palavra-passe",
  "download": {
    "downloadTitle": "Download AllDrivers",
    "downloadDescription": "Obtenha acesso antecipado ao aplicativo AllDrivers antes do lançamento na Play Store",
    "feature1": "Registo de Tempo TVDE",
    "feature2": "Rastreamento de Localização",
    "feature3": "Livro de Registo Digital",
    "downloadButton": "Download APK",
    "version": "Versão",
    "downloadNote": "Esta é uma versão pré-lançamento. A versão oficial estará disponível em breve na Google Play Store."
  },
  "success": "Sucesso",
  "error": "Erro",
  "resetPasswordDescription": "Introduza o seu email e enviaremos instruções para redefinir a sua palavra-passe.",
  "emailRequired": "Por favor, introduza o seu endereço de email",
  "passwordRequired": "A palavra-passe é obrigatória",
  "passwordTooShort": "A palavra-passe deve ter pelo menos 8 caracteres",
  "passwordMustContainUppercase": "A palavra-passe deve conter pelo menos uma letra maiúscula",
  "passwordMustContainLowercase": "A palavra-passe deve conter pelo menos uma letra minúscula",
  "passwordMustContainNumber": "A palavra-passe deve conter pelo menos um número",
  "passwordValidationError": "Erro de validação da palavra-passe",
  "fullNameRequired": "O nome completo é obrigatório",
  "phoneNumberRequired": "O número de telefone é obrigatório",
  "companyNameRequired": "O nome da empresa é obrigatório",
  "nipcRequired": "O NIPC é obrigatório",
  "nipcInvalidLength": "O NIPC deve ter 9 dígitos",
  "certidaoPermanenteRequired": "A certidão permanente é obrigatória",
  "certidaoPermanenteInvalidLength": "A certidão permanente deve ter 12 caracteres",
  "numeroLicencaRequired": "O número da licença é obrigatório",
  "numeroLicencaInvalidLength": "O número da licença deve ter 5 caracteres",
  "unexpectedError": "Ocorreu um erro inesperado",
  "nifRequired": "O NIF é obrigatório",
  "nifInvalidLength": "O NIF deve ter 9 dígitos",
  "addressRequired": "A morada é obrigatória",
  "licenseNumberRequired": "O número da licença é obrigatório",
  "workStartDateRequired": "A data de início de trabalho é obrigatória",
  "odometerRequired": "A leitura dos KM é obrigatória ao terminar uma sessão",
  "hours": "horas",
  "optional": "Opcional",
  "edited": "Editado",
  "date": "Data",
  "time": "Hora",
  "dateTime": "Data e Hora",
  "observationsRequiredWhenEdited": "Obrigatório quando editado",
  "eventLabels": {
    "session_in": "Início de sessão",
    "session_out": "Fim de sessão",
    "drive_in": "Início de condução",
    "drive_out": "Fim de condução"
  },
  "selectCountry": "Selecionar País",
  "validation": {
    "required": "Campo obrigatório",
    "invalidEmail": "Email inválido",
    "passwordMinLength": "A senha deve ter no mínimo 8 caracteres"
  },
  "loginInformation": "Informação de Login",
  "identification": "Identificação",
  "next": "Seguinte",
  "confirmPasswordRequired": "Por favor, confirme a sua palavra-passe",
  "passwordsDoNotMatch": "As palavras-passe não coincidem",
  "phoneNumberTooLong": "Número de telefone demasiado longo",
  "registerTitle": "Registar",
  "emailChangeWarning": "A alteração do seu email requererá verificação. Um email de confirmação será enviado para o novo endereço.",
  "manageDrivers": {
    "title": "Gerir Motoristas",
    "search": "Pesquisar",
    "noDriversFound": "Nenhum motorista encontrado.",
    "resend": "Reenviar",
    "resendSuccess": "Convite reenviado com sucesso",
    "resendError": "Erro ao reenviar convite",
    "invitationSent": "Convite enviado com sucesso",
    "status": {
      "active": "ativo",
      "inactive": "inativo",
      "pending": "pendente"
    }
  },
  "manageVehicles": "Gerir Veículos",
  "manageLicenses": "Gerir Licenças",
  "drivers": {
    "menu": "Motoristas"
  },
  "vehicles": {
    "menu": "Veículos"
  },
  "ownerDashboard": {
    "activeDrivers": "Condutores Ativos",
    "totalLicenses": "Total de Licenças",
    "availableLicenses": "Disponíveis",
    "hoursLicenses": "Licenças de Horas",
    "availableHoursLicenses": "Horas Disponíveis",
    "gpsLicenses": "Licenças GPS",
    "availableGpsLicenses": "GPS Disponíveis",
    "gpsActiveDevices": "Dispositivos GPS Ativos",
    "activeVsLicenses": "Ativos vs Licenças",
    "capacityTitle": "Capacidade da empresa",
    "licensesAndDrivers": "Licenças e condutores",
    "companyLicensesLabel": "Licenças da empresa",
    "ofLabel": "de",
    "usedLabel": "utilizadas",
    "activeDriversLabel": "Condutores ativos",
    "activeDriversUnavailable": "indisponível",
    "totalLabel": "total",
    "companyLabel": "empresa",
    "reservedByInvitationLabel": "Reservadas por convite",
    "payerToConfirmLabel": "Pagador por confirmar",
    "capacityUsedPurchased": "Vagas pagas pela empresa usadas / compradas",
    "capacitySelfPay": "Self-pay",
    "capacityPurchased": "Compradas",
    "capacitySeatsInUse": "Vagas da empresa em utilização",
    "capacityNeedsReview": "Por confirmar (incluídas acima)",
    "capacityReserved": "Reservadas",
    "capacityAvailable": "Disponíveis",
    "capacitySelfPayAssociations": "Associações self-pay",
    "capacitySelfPayZeroSeats": "As associações self-pay não utilizam vagas da empresa; consulte a cobertura de cada condutor.",
    "capacityUnavailable": "Capacidade indisponível",
    "activeDriversShort": "Ativos",
    "licensesShort": "Licenças",
    "activatedVsDeactivated": "Ativados vs Desativados",
    "activatedShort": "Ativados",
    "deactivatedShort": "Desativados",
    "gpsDevicesOffline": "Dispositivos Offline >24h",
    "inviteDriver": "Convidar Condutor",
    "inviteDriverDesc": "Enviar convite para novos condutores",
    "buyLicenses": "Comprar Licenças",
    "buyLicensesDesc": "Adquirir licenças adicionais para condutores",
    "buyHoursLicenses": "Comprar Licenças de Horas",
    "buyHoursLicensesDesc": "Adquirir licenças de registo de horas de condutores",
    "buyGpsLicenses": "Comprar Licenças GPS",
    "buyGpsLicensesDesc": "Adquirir licenças de rastreamento de dispositivos GPS",
    "companyStats": "Estatísticas da Empresa",
    "currentlyDriving": "A Conduzir",
    "avgDriveTime": "Tempo Médio de Condução",
    "avgDistance": "Distância Média",
    "perDriver": "por condutor",
    "perDay": "por dia",
    "driverLocations": "Localizações dos Condutores",
    "driverLocationsDesc": "Localização em tempo real dos seus condutores",
    "driverStatus": "Estado dos Condutores",
    "totalDrivers": "Total de Condutores",
    "inviteSuccess": "Convite enviado com sucesso",
    "choosePlan": "Escolha o seu plano",
    "save10Percent": "Poupe 10% com o plano anual",
    "14daystrial": "Teste grátis de 7 dias",
    "startTrial": "Iniciar teste de 7 dias",
    "buyNow": "Comprar Agora",
    "trialDaysLeft": "Dias de teste restantes",
    "days": "dias",
    "loadingLicenses": "A carregar informações de licenças...",
    "loadingDashboard": "A carregar dashboard...",
    "checkingLicenses": "A verificar licenças...",
    "chartOnWeb": "Gráfico na web",
    "dailyActiveUsers": "Utilizadores ativos diários",
    "monthlyActiveUsers": "Utilizadores ativos mensais",
    "noData": "Sem dados disponíveis",
    "sentAcceptedExpired": "enviados/aceites/expirados",
    "average": "média",
    "highOdometer": "Maior odômetro",
    "invitations": "Atividade dos convites",
    "invitationSubsetNote": "Os convites são agrupados pela data de criação; o grupo de 7 dias está incluído no de 30 dias.",
    "invitation7Days": "Últimos 7 dias",
    "invitation30Days": "Últimos 30 dias",
    "invitationSent": "Enviados",
    "invitationAccepted": "Aceites",
    "invitationExpired": "Expirados",
    "invitationUnavailable": "Dados dos convites indisponíveis",
    "addDriver": "Adicionar Motorista",
    "addDriverDesc": "Adicionar motorista existente à sua empresa",
    "becomeDriver": "Eu também sou condutor",
    "becomeDriverDesc": "Guardar o seu perfil de condutor para onboarding futuro",
    "becomeDriverTitle": "Quer também conduzir?",
    "becomeDriverCta": "Tornar-me motorista",
    "seatsInUseTitle": "Todas as licenças estão em uso",
    "buyLicenseCta": "Comprar licença",
    "completeDriverProfile": "Guardar perfil"
  },
  "buyLicense": {
    "title": "Comprar Licenças",
    "description": "Adquirir licenças adicionais para condutores da sua empresa",
    "currentLicenses": "Licenças Atuais",
    "availableLicenses": "Licenças Disponíveis",
    "activeDrivers": "Condutores Ativos",
    "selectPlan": "Selecione um plano de subscrição",
    "selectQuantity": "Quantas licenças precisa?",
    "quantity": "Número de licenças",
    "summary": "Resumo do Pedido",
    "plan": "Plano",
    "licenses": "Licenças",
    "total": "Total",
    "setupFee": "Taxa de instalação",
    "once": "uma vez",
    "monthlyAmount": "Valor mensal",
    "totalFirstInvoice": "Total (1.ª fatura)",
    "purchase": "Comprar",
    "processing": "A Processar...",
    "errorFetchingPlans": "Erro ao obter planos de subscrição",
    "noPlanSelected": "Por favor, selecione um plano primeiro",
    "invalidQuantity": "Número de licenças inválido",
    "stripeInitError": "Falha ao inicializar o sistema de pagamento",
    "subscriptionError": "Falha ao criar a subscrição",
    "noData": "Nenhum dado recebido do servidor",
    "noPaymentIntent": "Nenhuma informação de pagamento recebida",
    "purchaseFailed": "Processo de pagamento falhou. Por favor, tente novamente.",
    "portalOpenFailed": "Falha ao abrir o portal de cobrança",
    "paymentCancelled": "Pagamento foi cancelado",
    "webPaymentError": "Falha ao completar o pagamento",
    "pricePerLicense": "Preço por Licença",
    "totalPrice": "Preço Total",
    "paymentMethod": "Método de Pagamento",
    "creditCard": "Cartão de Crédito",
    "confirmPurchase": "Confirmar Compra",
    "cancel": "Cancelar",
    "success": "Compra Bem-sucedida",
    "successMessage": "As suas licenças foram adicionadas à sua conta",
    "error": "Falha na Compra",
    "errorMessage": "Ocorreu um erro ao processar a sua compra. Por favor, tente novamente.",
    "insufficientFunds": "Fundos Insuficientes",
    "insufficientFundsMessage": "O seu método de pagamento não tem fundos suficientes para esta compra.",
    "invalidCard": "Cartão Inválido",
    "invalidCardMessage": "As informações do cartão fornecidas são inválidas. Por favor, verifique e tente novamente.",
    "networkError": "Erro de Rede",
    "networkErrorMessage": "Houve um problema ao conectar ao serviço de pagamento. Por favor, tente novamente.",
    "quantityRequired": "Por favor, selecione o número de licenças a comprar",
    "paymentMethodRequired": "Por favor, selecione um método de pagamento",
    "processingPayment": "A processar pagamento...",
    "paymentSuccess": "Pagamento bem-sucedido!",
    "paymentError": "Falha no pagamento. Por favor, tente novamente.",
    "licenseAdded": "Licenças adicionadas à sua conta",
    "licenseAddedMessage": "As suas novas licenças foram adicionadas à sua conta com sucesso.",
    "refreshAccount": "A atualizar a sua conta...",
    "refreshError": "Erro ao atualizar a conta. Por favor, atualize a página manualmente.",
    "purchaseSuccessUpdating": "Compra de licença realizada com sucesso! A atualizar a sua conta...",
    "purchaseSuccessUpdated": "Compra de licença realizada com sucesso! A sua conta foi atualizada.",
    "purchaseSuccessRefreshError": "Compra de licença realizada com sucesso, mas houve um erro ao atualizar a sua conta. Por favor, atualize a página.",
    "manageInStripe": "Gerir no Stripe",
    "annualSavings": "Poupe 10% com o plano anual",
    "pay": "Pagar Agora"
  },
  "interval": {
    "month": "mês",
    "year": "ano"
  },
  "inviteForm": {
    "title": "Convidar Condutor",
    "licensePayerTitle": "Quem paga este convite?",
    "licensePayerCompany": "A empresa paga",
    "licensePayerSelf": "O condutor paga",
    "licensePayerRequired": "Selecione quem vai pagar antes de enviar o convite.",
    "companyLicenseLoading": "A verificar as licenças disponíveis da empresa...",
    "companyLicenseUnavailable": "Não foi possível confirmar a disponibilidade de licenças da empresa. Escolha pagamento pelo condutor ou tente novamente.",
    "companyLicenseError": "Não foi possível verificar as licenças da empresa. Escolha pagamento pelo condutor ou tente novamente.",
    "email": "Email",
    "emailRequired": "Email é obrigatório",
    "emailInvalid": "Formato de email inválido",
    "fullName": "Nome Completo (Opcional)",
    "fullNameRequired": "Nome completo é obrigatório",
    "phoneNumber": "Número de Telefone (Opcional)",
    "phoneNumberRequired": "Número de telefone é obrigatório",
    "phoneNumberInvalid": "Formato de número de telefone inválido",
    "nif": "NIF (Opcional)",
    "nifRequired": "NIF é obrigatório",
    "nifInvalid": "NIF deve ter 9 dígitos",
    "address": "Morada (Opcional)",
    "addressRequired": "Morada é obrigatória",
    "licenseNumber": "Número da CMTVDE (Opcional)",
    "licenseNumberRequired": "Número da CMTVDE é obrigatório",
    "licenseNumberInvalid": "Formato da CMTVDE inválido. Use NNNNNNNN+/AAAA.",
    "workStartDate": "Data de Início de Trabalho (Opcional)",
    "workStartDateRequired": "Data de início de trabalho é obrigatória",
    "dateOfBirth": "Data de Nascimento (Opcional)",
    "dateOfBirthRequired": "Data de nascimento é obrigatória",
    "submit": "Enviar Convite",
    "cancel": "Cancelar",
    "back": "Voltar",
    "optional": "(Opcional)",
    "required": "(Obrigatório)",
    "licenseType": "Tipo de Licença (Opcional)",
    "licenseTypeRequired": "Tipo de licença é obrigatório",
    "licenseExpiry": "Data de Validade da Licença (Opcional)",
    "licenseExpiryRequired": "Data de validade da licença é obrigatória",
    "licenseCountry": "País da Licença (Opcional)",
    "licenseCountryRequired": "País da licença é obrigatório",
    "optionalFieldsExplanation": "Pode adicionar mais informações sobre o condutor (opcional)",
    "addMoreInfo": "Adicionar Mais Informações",
    "noLicensesAvailable": "Nenhuma licença disponível para convidar condutores.",
    "buyLicensesLink": "Clique aqui para comprar mais licenças",
    "expirationInfo": "Este convite expirará em 7 dias."
  },
  "common": {
    "cancel": "Cancelar",
    "remove": "Remover",
    "loading": "A carregar...",
    "invite": "Convidar",
    "add": "Adicionar",
    "buy": "Comprar",
    "knowMore": "Saber Mais",
    "all": "Todos",
    "status": "Estado",
    "success": "Sucesso",
    "error": "Erro",
    "retry": "Tentar novamente",
    "now": "Agora",
    "minutesAgo": "{{count}}m atrás",
    "hoursAgo": "{{count}}h atrás",
    "daysAgo": "{{count}}d atrás"
  },
  "transfer": {
    "vehicleTitle": "Transferir Veículo",
    "vehicleDescription": "Selecione a empresa para a qual deseja transferir este veículo. Todas as atribuições de condutores serão removidas.",
    "driverTitle": "Transferir Condutor",
    "driverDescription": "Selecione a empresa para a qual deseja transferir este condutor. Todas as atribuições de veículos serão removidas.",
    "selectCompany": "Por favor, selecione uma empresa de destino",
    "error": "Erro ao transferir",
    "errorLoadingCompanies": "Erro ao carregar empresas",
    "noOtherCompanies": "Precisa de pelo menos uma outra empresa para transferir.",
    "transferButton": "Transferir",
    "alsoTransferVehicles": "Também transferir {{count}} veículos relacionados",
    "alsoTransferDrivers": "Também transferir {{count}} condutores relacionados"
  },
  "inviteDriverModal": {
    "title": "Convidar Condutor",
    "optionalFieldsExplanation": "Preencha campos opcionais como nome completo, número de telefone, endereço, número da licença e datas para fornecer mais detalhes. Pode ignorar estes por agora.",
    "addMoreInfo": "Adicionar mais informações",
    "sendButton": "Enviar",
    "activateDialogTitle": "Ativar Condutor",
    "activateDialogMessage": "Este condutor está na sua frota mas inativo. Deseja ativá-lo?",
    "activate": "Ativar",
    "activateError": "Não foi possível ativar este condutor. Tente novamente."
  },
  "invalidInvitationLink": "Link de convite inválido",
  "invitationNotFound": "Convite não encontrado ou expirado.",
  "acceptInvitation": "Aceitar Convite",
  "invitationTitle": "Convite da {{company}}",
  "invitationLoginMessage": "Faça login para aceitar o convite",
  "invitationRegistrationMessage": "Complete o registo para aceitar o convite",
  "invitationExpiredTitle": "Convite expirado",
  "invitationExpiredMessage": "O convite de {{company}} para {{email}} já não é válido — convites duram 7 dias.",
  "invitationRequestRenewal": "Pedir novo convite",
  "invitationRenewalRequested": "Pedido enviado — {{company}} foi avisada para lhe enviar um novo convite.",
  "invitationRenewalError": "Não foi possível pedir um novo convite. Tente novamente.",
  "onboardingWelcomeTitle": "Bem-vindo à nossa aplicação!",
  "onboardingWelcomeDescription": "Vamos configurar algumas informações importantes antes de começar. Isso ajudará a personalizar a sua experiência.",
  "continue": "Continuar",
  "finish": "Concluir",
  "retry": "Tentar Novamente",
  "errorAddingVehicle": "Erro ao adicionar veículo.",
  "loadingVehicleInfo": "A carregar informações do veículo...",
  "vehicleDataFound": "Encontrámos as informações do seu veículo:",
  "edit": "Editar",
  "vehicleFormIntro": "Por favor, forneça informações sobre o seu veículo:",
  "licensePlateError": "Formato inválido. Utilize XX-XX-XX (letras e números)",
  "permissionsTitle": "Permissões da Aplicação",
  "permissionsDescription": "Para oferecer a melhor experiência, precisamos das seguintes permissões:",
  "notificationsPermission": "Notificações",
  "notificationsPermissionMessage": "Para receber notificações, precisa de ativar esta permissão nas definições do dispositivo.",
  "notificationsPermissionTitle": "Notificações",
  "notificationsPermissionDescription": "Para receber alertas e informações importantes",
  "locationPermission": "Localização",
  "locationPermissionMessage": "Para usar a localização atual, precisa de ativar esta permissão nas definições do dispositivo.",
  "locationForegroundPermissionTitle": "Localização (Em primeiro plano)",
  "locationForegroundPermissionDescription": "Para mostrar a sua localização atual no mapa",
  "locationBackgroundError": "Permissão necessária",
  "locationBackgroundErrorMessage": "Precisa de ativar a localização em primeiro plano antes de ativar a localização em segundo plano.",
  "backgroundLocationPermission": "Localização (Segundo plano)",
  "backgroundLocationPermissionMessage": "Para usar a localização em segundo plano, precisa de ativar esta permissão nas definições do dispositivo e selecionar 'Permitir sempre'.",
  "employmentTitle": "Informação de Emprego",
  "loadingEmploymentInfo": "A carregar informações de emprego...",
  "employmentDataFound": "Encontrámos as informações do seu emprego:",
  "employmentFormIntro": "Por favor, forneça informações sobre o seu emprego:",
  "nipcError": "O NIPC deve conter 9 dígitos",
  "companyNipc": "NIPC da Empresa",
  "invitations": "Convites",
  "driverActive": "Condutor já ativo.",
  "driverInactive": "Condutor inativo na frota.",
  "invitePending": "Convite pendente.",
  "alerts": {
    "movementDetected": "Encontra-se em movimento, mas não está em modo de condução. Por favor, inicie o modo de condução.",
    "stationaryDetected": "Encontra-se parado há algum tempo. Considere parar o modo de condução.",
    "reopenAppBeforeStartingTracking": "Reabra a aplicação antes de iniciar a condução ou o rastreamento da sessão.",
    "locationPermissionDenied": "Permissão de localização não concedida. Clique para tentar novamente.",
    "locationPermissionRequired": "Permissão de Localização Necessária",
    "locationPermissionRequiredMessage": "A aplicação precisa de acesso à sua localização para funcionar corretamente. Por favor, conceda a permissão de localização.",
    "locationPermissionRetryMessage": "Se acabou de alterar as permissões de localização nas definições do seu navegador, por favor, atualize a página para continuar.",
    "locationSettingsInvalid": "Localização Indisponível",
    "locationSettingsInvalidMessage": "Não foi possível obter a sua localização. Verifique se o GPS está ativo e se o modo de localização está em alta precisão.",
    "locationTrackingDegraded": "O rastreamento automático da localização está temporariamente indisponível. A sua sessão de trabalho continua disponível.",
    "openDeviceSettings": "Abrir Definições",
    "locationSettingsManualFallback": "Não foi possível obter a sua localização. Ative o GPS nas definições ou indique o local manualmente.",
    "tryAgain": "Tentar Novamente",
    "refreshPage": "Atualizar Página",
    "alert": "Alerta",
    "confirm": "Confirmar"
  },
  "notificationsTitle": "Notificações",
  "notificationsDescription": "Para receber alertas e informações importantes",
  "foregroundLocationDescription": "Para mostrar a sua localização atual no mapa",
  "backgroundLocationDescription": "Para continuar rastreando mesmo quando o app estiver fechado",
  "locationRequiredGeneric": "A localização é obrigatória. A sua localização não foi partilhada.",
  "manualLocationPrompt": "Em alternativa, insira a sua localização abaixo (morada, cidade ou local).",
  "manualLocationLabel": "A sua localização (morada)",
  "locationNotFound": "Não foi possível encontrar essa localização.",
  "tryAllowLocation": "Tentar permitir localização novamente",
  "myVehicles": {
    "menu": "Os Meus Veículos",
    "title": "Os Meus Veículos",
    "addVehicle": "Adicionar Veículo",
    "addFirstVehicle": "Adicionar o Meu Primeiro Veículo",
    "emptyTitle": "Ainda não tem veículos",
    "emptyMessage": "Adicione o seu primeiro veículo para começar a registar as suas viagens",
    "noDetails": "Sem detalhes",
    "tooltipTitle": "Sobre os veículos múltiplos",
    "tooltipMessage": "A maioria dos motoristas usa apenas um veículo, mas pode adicionar mais se necessário",
    "unassignTitle": "Remover Veículo",
    "confirmUnassign": "Tem a certeza que deseja remover o veículo {{plate}} da sua frota?",
    "editVehicleInfo": "Editar Veículo"
  },
  "vehicleModal": {
    "registrationNumberImmutable": "A matrícula não pode ser alterada. Para uma matrícula diferente, crie um novo veículo."
  },
  "fuelTypes": {
    "gasolina": "Gasolina",
    "gasoleo": "Gasóleo",
    "bifuel": "Bi-fuel",
    "hibrido": "Híbrido",
    "eletrico": "Elétrico"
  },
  "vehicleSelection": {
    "title": "Selecione o Veículo",
    "subtitle": "Escolha o veículo que irá utilizar nesta sessão de trabalho",
    "confirm": "Confirmar"
  },
  "errors": {
    "errorLoadingData": "Erro ao carregar dados",
    "errorLoadingDataMessage": "Houve um problema ao carregar os seus dados. Por favor, tente novamente.",
    "reloadPage": "Recarregar Página"
  },
  "purchase": {
    "success": {
      "title": "🎉 Compra Bem-sucedida!",
      "messageNew": "As suas licenças GPS foram compradas com sucesso!",
      "messageUpdated": "As suas licenças GPS foram atualizadas com sucesso!",
      "licenses": "Licenças Compradas:",
      "gpsLicenses": "Licenças GPS",
      "ready": "Pode agora atribuir estas licenças aos seus condutores e veículos.",
      "close": "Entendido!"
    }
  },
  "licenseType": {
    "selectType": "Selecionar tipo...",
    "tvde": "Operador TVDE",
    "taxi": "Taxi",
    "lightGoods": "Veículos ligeiros de mercadorias",
    "roadTransport": "Transporte Rodoviário (Sem Tacógrafo)",
    "other": "Outro"
  },
  "languages": {
    "english": "🇬🇧 English",
    "portuguese": "🇵🇹 Português",
    "portugueseBR": "🇧🇷 Português (BR)"
  },
  "register": {
    "choiceTitle": "Registar",
    "driverButton": "Condutor",
    "ownerButton": "Proprietário de Frota",
    "registerTitle": "Registar",
    "registerDriverTitle": "Registo de Condutor",
    "registerOwnerTitle": "Registar como Proprietário de Frota",
    "next": "Seguinte",
    "back": "Voltar",
    "submitButton": "Enviar",
    "loginInformation": "Informação de Login",
    "identification": "Identificação",
    "driverDetails": "Detalhes do Condutor",
    "companyInformation": "Informação da Empresa",
    "registrationSuccessTitle": "Registado com sucesso!",
    "registrationSuccessMessage": "Confirme o seu email para completar o registo.",
    "okButton": "OK"
  },
  "changePaymentMethod": {
    "title": "Atualizar Método de Pagamento",
    "description": "Será solicitado que introduza os detalhes do seu novo método de pagamento.",
    "continue": "Continuar",
    "update": "Atualizar Método de Pagamento",
    "processing": "A Processar...",
    "success": "Sucesso",
    "error": "Erro",
    "paymentMethodUpdated": "Método de pagamento atualizado com sucesso",
    "paymentMethodError": "Falha ao atualizar método de pagamento",
    "paymentCancelled": "Pagamento cancelado",
    "webPaymentError": "Falha ao concluir pagamento"
  },
  "errorCancelingInvitation": "Erro ao cancelar convite",
  "errorFetchingInvitations": "Erro ao carregar convites",
  "errorResendingInvitation": "Erro ao reenviar convite",
  "expired": "Expirado",
  "expiresToday": "Expira hoje",
  "expiresTomorrow": "Expira amanhã",
  "invitationsPending": "pendente(s)",
  "loadingInvitations": "A carregar convites...",
  "noInvitations": "Sem convites pendentes.",
  "resend": "Reenviar",
  "assign": "Atribuir",
  "completePurchase": "Concluir compra",
  "continueToPayment": "Continuar para pagamento",
  "continueToTrial": "Iniciar período de teste",
  "errorOpeningPortal": "Erro ao abrir portal de pagamento",
  "paymentDescription": "Será redirecionado para a nossa página de pagamento seguro para concluir a compra.",
  "paymentError": "Ocorreu um erro. Por favor, tente novamente.",
  "paymentModalTitle": "Concluir compra",
  "trialDescription": "Será redirecionado para a nossa página de pagamento seguro para iniciar o período de teste.",
  "statusLabels": {
    "pending": "Pendente"
  },
  "notifications.stopDriveButton": "Parar de Conduzir",
  "notifications.cancelButton": "Cancelar",
  "notifications.activeTracking": "Rastreamento Ativo",
  "notifications.locationBeingMonitored": "A sua localização está a ser monitorizada.",
  "notifications.attention": "Atenção",
  "notifications.movementDetectedBody": "Encontra-se em movimento, mas não está em modo de condução. Por favor, inicie o modo de condução.",
  "notifications.stationaryDetectedBody": "Está parado há mais de {{minutes}} minutos. Considere parar de conduzir.",
  "notifications.drivingStatus": "Estado de Condução",
  "notifications.driving": "A conduzir",
  "notifications.activeSession": "Sessão Ativa",
  "notifications.tapToChange": "Toque para alterar o estado de condução",
  "notifications.startDrivingButton": "Iniciar Condução",
  "notifications.stopDrivingButton": "Parar de Conduzir",
  "notifications": {
    "activeSession": "Sessão Ativa",
    "activeTracking": "Rastreamento Ativo",
    "attention": "Atenção",
    "cancelButton": "Cancelar",
    "driving": "A conduzir",
    "drivingStatus": "Estado de Condução",
    "locationBeingMonitored": "A sua localização está a ser monitorizada.",
    "movementDetectedBody": "Encontra-se em movimento, mas não está em modo de condução. Por favor, inicie o modo de condução.",
    "startDrivingButton": "Iniciar Condução",
    "stationaryDetectedBody": "Está parado há mais de {{minutes}} minutos. Considere parar de conduzir.",
    "stopDriveButton": "Parar de Conduzir",
    "stopDrivingButton": "Parar de Conduzir",
    "tapToChange": "Toque para alterar o estado de condução"
  },
  "invitationRecipient": "Conta que aceita: {{email}}",
  "invitationPayerCompany": "Pagador: empresa",
  "invitationPayerSelf": "Pagador: próprio",
  "invitationPayerUnknown": "Pagador não confirmado. Peça esclarecimento à empresa antes de aceitar.",
  "invitationCompanyConsent": "Ao aceitar, a empresa de trabalho passa a ser a indicada neste convite. A sessão já aberta e o histórico conservam a atribuição original.",
  "invitationConfirm": "Aceitar convite",
  "invitationIdentityChanged": "A conta ou as condições do convite mudaram. Volte a abrir o convite para confirmar.",
  "invitationAcceptanceFailed": "Não foi possível aceitar o convite. Tente novamente ou contacte o suporte.",
  "drivingLimit": {
    "warningTitle": "Limite de condução a aproximar-se",
    "warningBody": "Faltam {{minutes}} min para atingir {{hours}} h de condução nas últimas 24 h, se continuar a conduzir.",
    "reachedTitle": "Limite de condução atingido",
    "reachedBody": "Atingiu {{hours}} h de condução nas últimas 24 h. Pare em segurança e faça uma pausa.",
    "noticeWarning": "Restam {{remaining}} até ao limite de {{hours}} h de condução em 24 h.",
    "noticeReached": "Limite de {{hours}} h de condução em 24 h atingido.",
    "noticeReachedUntil": "Limite de {{hours}} h de condução em 24 h atingido. Volta a ficar abaixo do limite às {{time}}."
  },
  "workTime": {
    "states": {
      "resting": "Sessão inativa",
      "available": "Sessão ativa",
      "driving": "A conduzir"
    },
    "since": "desde as {{time}}",
    "timerA11y": "{{state}} há {{duration}}",
    "limits": {
      "title": "Limites de condução",
      "subtitle": "Limites de referência: são só avisos e nada fica bloqueado.",
      "viewAll": "Ver limites",
      "close": "Fechar",
      "usedOf": "{{used}} de {{limit}}",
      "remaining": "Restam {{remaining}}",
      "noData": "Sem registo recente",
      "rolling24h": {
        "title": "Condução nas últimas 24 h",
        "short": "24 h"
      },
      "week": {
        "title": "Condução esta semana",
        "short": "Semana",
        "range": "segunda a domingo",
        "reached": "Limite semanal atingido. Mais condução passa das 60 h."
      },
      "fourMonth": {
        "title": "Média de condução em 4 meses",
        "short": "4 meses",
        "value": "{{avg}} h por semana (limite {{limit}} h)",
        "available": "Para ficar abaixo das {{limit}} h de média: até {{hours}} h de condução esta semana.",
        "window": "Média das últimas {{weeks}} semanas, incluindo esta.",
        "over": "Média acima das {{limit}} h. Conduza menos horas nas próximas semanas.",
        "partial": "Ainda não tem 17 semanas de registos: as semanas sem registo contam como 0 h.",
        "above": "Acima do limite",
        "summaryValue": "média {{avg}} h / {{limit}} h"
      },
      "levels": {
        "ok": "Dentro do limite",
        "warning": "Atenção",
        "critical": "Quase no limite",
        "reached": "Limite atingido",
        "unknown": "Sem registo"
      },
      "weekWarning": "{{used}} de condução esta semana. Limite: {{limit}}.",
      "fourMonthWarning": "Média de condução em 4 meses: {{avg}} h por semana. Limite: {{limit}} h.",
      "howWeCount": {
        "title": "Como contamos",
        "driving": "Só conta o tempo em «A conduzir», em todas as plataformas.",
        "periods": "24 h: as últimas 24 horas. Semana: de segunda a domingo. 4 meses: média por semana das últimas 17 semanas.",
        "notCounted": "Sessão ativa sem conduzir e sessão fechada não contam. Tempo sem registo nunca conta como descanso.",
        "disclaimer": "São limites de referência, só para avisar. Mostram o tempo de condução registado na app e não são um registo oficial de horas."
      },
      "summaryValue": "{{used}} / {{limit}}"
    },
    "notifications": {
      "ongoingBody": "Desde as {{time}}.",
      "weekWarningTitle": "Condução na semana: {{used}} h de {{limit}} h",
      "weekWarningBody": "Restam {{remaining}} h de condução até ao limite semanal.",
      "fourMonthWarningTitle": "Média de condução em 4 meses perto do limite",
      "fourMonthWarningBody": "Média de {{avg}} h por semana. Limite: {{limit}} h."
    }
  },
  "mapLoading": {
    "title": "A preparar o mapa em tempo real",
    "subtitle": "A carregar a localização e os controlos antes de o percurso aparecer.",
    "loading": "A carregar o mapa…",
    "errorTitle": "Não foi possível carregar o mapa",
    "errorMessage": "Verifique a ligação e tente novamente. Os controlos da sessão continuam a funcionar.",
    "retry": "Tentar novamente"
  }
}
